// Databases.jsx
import SkillCard from './SkillCard';

const Databases = () => {
  const databaseSkills = [
    { name: 'PostgreSQL', icon: 'bx bxl-postgresql' },
    { name: 'MySQL', icon: 'bx bxs-data' },
    { name: 'MongoDB', icon: 'bx bxl-mongodb' },
    { name: 'SQLite', icon: 'devicon-sqlite-plain' },
    { name: 'Redis', icon: 'devicon-redis-plain' },
    { name: 'Prisma ORM', icon: 'devicon-prisma-original' },
    { name: 'TypeORM', icon: 'bx bx-data' },
    { name: 'Mongoose', icon: 'bx bxl-mongodb' },
  ];

  return (
    <div className="skills__content">
      <div className="skills__content-header">
        <h3 className="skills__title">Databases & ORMs</h3>
        <p className="skills__description">Relational & NoSQL databases with modern ORMs</p>
      </div>
      <div className="skills__grid">
        {databaseSkills.map((skill, index) => (
          <SkillCard
            key={index}
            name={skill.name}
            icon={skill.icon}

          />
        ))}
      </div>
    </div>
  );
};

export default Databases;
